import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-mobile-config.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-mobile-config.component.scss?ngResource";
import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { EditMobileConfigConstants, FormError, ValidationMessage } from "./edit-mobile-config.constants";
import { LogValidatorErrors } from "../../../organisation-config/shared/log-validator-errors";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { MobileConfigSettingsService } from "../../mobile-config-settings/mobile-config-settings.service";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
import { AppConfig } from "../../../../app.config";
let EditMobileConfigComponent = class EditMobileConfigComponent {
    activeModal;
    mobileconfigService;
    changeDetectorRef;
    appController;
    modalTitle;
    mobId;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    editMObileConfigForm;
    formErrors = FormError;
    validationMessage = ValidationMessage;
    logValidatorErrors = LogValidatorErrors;
    updateLabel = SharedConstants.UPDATE_LABEL;
    cancelLabel = SharedConstants.CANCEL_LABEL;
    validationErrMsg = SharedConstants.FORM_NOT_VALID;
    minAppVersion = EditMobileConfigConstants.MIN_APP_VERSION_FORM_CONTROL;
    minAppVersionTextPlaceHolder = EditMobileConfigConstants.MIN_APP_VERSION_TEXT_PLACEHOLDER;
    maxOfflineHours = EditMobileConfigConstants.MAX_OFFLINE_HOURS_FORM_CONTROL;
    maxOfflineHoursTextPlaceHolder = EditMobileConfigConstants.MAX_OFFLINE_HOURS_TEXT_PLACEHOLDER;
    allowOfflineAccess = EditMobileConfigConstants.ALLOW_OFFLINE_ACCESS_FORM_CONTROL;
    allowOfflineAccessTextPlaceHolder = EditMobileConfigConstants.ALLOW_OFFLINE_ACCESS_TEXT_PLACEHOLDER;
    allowOfflineAccessChecked = false;
    mobileConfigUpdatedMessage = EditMobileConfigConstants.MOBILE_CONFIG_UPDATED_MSG;
    selectedMobileConfig;
    errorObjectName = EditMobileConfigConstants.ERROR_OBJECT_NAME;
    objectName = EditMobileConfigConstants.OBJECT_NAME;
    formData;
    getMobileConfigDetailsSubscription;
    updateMobileConfigSubscription;
    constructor(activeModal, mobileconfigService, changeDetectorRef, appController) {
        this.activeModal = activeModal;
        this.mobileconfigService = mobileconfigService;
        this.changeDetectorRef = changeDetectorRef;
        this.appController = appController;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.editMObileConfigForm = new FormGroup({
            minAppVersion: new FormControl(null, [Validators.required, Validators.pattern(RegExp(/\d{1,3}\.\d{1,3}\.?\d{1,3}?/g)), Validators.maxLength(12)]),
            maxOfflineHours: new FormControl(null, [Validators.required, Validators.pattern(RegExp(/[0-9]{1,2}$/)), Validators.maxLength(2)]),
            allowOfflineAccess: new FormControl(null, Validators.required),
        });
        this.getMobileConfig();
    }
    SaveMobileConfig() {
        if (this.editMObileConfigForm.valid) {
            const mobileConfigData = {
                minAppVersion: this.editMObileConfigForm.get(this.minAppVersion).value,
                maxOfflineHours: this.editMObileConfigForm.get(this.maxOfflineHours).value,
                allowOfflineAccess: this.editMObileConfigForm.get(this.allowOfflineAccess).value,
            };
            this.patchData(mobileConfigData);
        }
        else {
            this.appController.showMessage(this.validationErrMsg, AlertType.Warning);
        }
    }
    changeAllowOfflineAccess(event) {
        const checkBoxStatus = event.target.checked;
        if (checkBoxStatus) {
            this.editMObileConfigForm.get(this.allowOfflineAccess).patchValue(true);
        }
        else {
            this.editMObileConfigForm.get(this.allowOfflineAccess).patchValue(false);
        }
    }
    onBtnCancelClicked() {
        this.activeModal.close();
    }
    onBtnUpdateClicked() {
        this.SaveMobileConfig();
    }
    getMobileConfig() {
        this.getMobileConfigDetailsSubscription = this.mobileconfigService.getMobileConfigDetails(this.mobId).subscribe((response) => {
            this.selectedMobileConfig = response;
            this.allowOfflineAccessChecked = this.selectedMobileConfig.allowOfflineAccess;
            this.loadFormData();
        }, (error) => {
            this.appController.handleServerErrorMessage(this.objectName, error, CRUDOperation.Get);
        });
    }
    patchData(mobileConfigData) {
        this.updateMobileConfigSubscription = this.mobileconfigService.updateMobileConfig(this.selectedMobileConfig.id, mobileConfigData).subscribe(() => {
            if (!this.formData) {
                this.appController.showMessage(this.mobileConfigUpdatedMessage, AlertType.Success);
                this.activeModal.close(true);
            }
        }, (error) => {
            this.appController.handleServerErrorMessage(this.objectName, error, CRUDOperation.Update);
        });
    }
    loadFormData() {
        this.editMObileConfigForm.get(this.minAppVersion).patchValue(this.selectedMobileConfig.minAppVersion);
        this.editMObileConfigForm.get(this.maxOfflineHours).patchValue(this.selectedMobileConfig.maxOfflineHours);
        this.editMObileConfigForm.get(this.allowOfflineAccess).patchValue(this.selectedMobileConfig.allowOfflineAccess);
        this.editMObileConfigForm.updateValueAndValidity();
        this.changeDetectorRef.detectChanges();
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: MobileConfigSettingsService },
        { type: ChangeDetectorRef },
        { type: AppControllerService }
    ];
    static propDecorators = {
        modalTitle: [{ type: Input }],
        mobId: [{ type: Input }]
    };
};
EditMobileConfigComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-edit-mobile-config",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], EditMobileConfigComponent);
export { EditMobileConfigComponent };
